import { LitElement, css, html, unsafeCSS } from '@hh/global.js'

class HeaderSearchDetails extends LitElement {
  static properties = {
    open: {
      type: Boolean,
      reflect: true,
    },

    headerHeight: {
      state: true,
    },
  }

  constructor() {
    super()

    this.open = false
    this.headerHeight = 0
  }

  connectedCallback() {
    super.connectedCallback()
    this.setHeaderHeight()
    this.handleCloseTrigger()
    this.handleEscKey()
    this.handleInputChange()
  }

  updated() {
    const inputEl = this.querySelector('.js-header-search-details-input')

    if (this.open) {
      setTimeout(() => {
        inputEl?.focus()
      }, 200);
      this.closest('.header')?.classList.add('header--search-details-open')
      document.body.classList.add('overflow-hidden');
      this.setHeaderHeight()
    } else {
      inputEl.value = '';
      this.closest('.header')?.classList.remove('header--search-details-open')
      document.body.classList.remove('overflow-hidden');
    }
  }

  toggle(e = false) {
    if (e) {
      e.preventDefault();
      // Check if the event is from a keyboard 'Enter' or 'Space' key press
      if (e.type === 'keydown' && (e.key !== 'Enter' && e.key !== ' ')) return;
    }
    
    this.open = !this.open;
  }

  setHeaderHeight() {
    const headerEl = document.querySelector('.js-section-header')

    this.headerHeight = headerEl.getBoundingClientRect()?.height || 0
  }

  handleCloseTrigger() {
    const modalCloseEls = this.querySelectorAll(
      '.js-header-search-details-close'
    )

    modalCloseEls?.forEach((el) => {
      el.addEventListener('click', () => {
        this.open = false
      })
    })
  }

  handleEscKey() {
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.open = false
      }
    })
  }

  handleInputChange() {
    const inputEl = this.querySelector('.js-header-search-details-input')
    const submitEl = this.querySelector('.js-header-search-details-submit')
    const handleChange = (e) => {
      if (!!e.currentTarget.value) {
        submitEl.removeAttribute('disabled')
      } else {
        submitEl.setAttribute('disabled', true)
      }
    }

    inputEl.addEventListener('change', handleChange)
    inputEl.addEventListener('keyup', handleChange)
  }

  render() {
    return html`
      <style>
        :host {
          --header-height: ${unsafeCSS(this.headerHeight)}px;
        }
      </style>
      <div ?open="${this.open}">
        <summary @click="${this.toggle}">
          <slot name="summary"></slot>
        </summary>
        <div class="header-search-detail__content">
          <hh-focus-trap active="${this.open}">
            <slot name="details">
          </hh-focus-trap>
        </div>
      </div>
      `
  }

  static get styles() {
    return css`
      summary {
        list-style-type: none;
        cursor: pointer;
      }
      summary::-webkit-details-marker {
        display: none
      }
    `
  }
}

customElements.define('header-search-details', HeaderSearchDetails)
